import { section } from "@/neon";
import mobileCarousel from "@/lib/mobile-carousel";

const sel = {
  slider: "[data-slider]",
};

section("collection-list", {
  onLoad() {
    const slider = this.container.querySelector(sel.slider);
    this.mobileCarousel = mobileCarousel(slider, {
      groupCells: 2,
    });
  },

  onUnload() {
    this.mobileCarousel.destroy();
  },

  onBlockSelect({ target }) {
    this.mobileCarousel.select(target.dataset.index);
  },
});
